import { appConfig } from '../src/config-builder/app-config.ts';
import { configurePermissions } from '../src/permissions/policy-matrix.ts';

// Access policies per entity type: `1` = allowed, `0`/omitted = denied. Elevation vs. self rows,
// product home rows, publicRead and row conditions are all explained in cella/PERMISSIONS.md.

export const { policyMatrix, publicReadGrants, accessScopes } = configurePermissions(
  appConfig.entityTypes,
  ({ entityType, channels, publicRead }) => {
    switch (entityType) {
      case 'organization':
        // self (this organization): create is inert here: org creation is gated by tenant quota, not this policy
        channels.organization.admin({ read: 1, update: 1, delete: 1 });
        channels.organization.member({ read: 1, update: 0, delete: 0 });
        break;
      case 'workspace':
        channels.organization.admin({ create: 1, read: 1, update: 1, delete: 1 });
        channels.organization.member({ create: 1, read: 1, update: 0, delete: 0 });

        channels.workspace.admin({ read: 1, update: 1, delete: 1 });
        channels.workspace.member({ read: 1, update: 0, delete: 0 });
        channels.workspace.guest({ read: 0, update: 0, delete: 0 });
        break;
      case 'project':
        publicRead();
        channels.organization.admin({ create: 1, read: 1, update: 1, delete: 1 });
        channels.organization.member({ create: 1, read: 1, update: 0, delete: 0 });

        channels.project.admin({ read: 1, update: 1, delete: 1 });
        channels.project.member({ read: 1, update: 0, delete: 0 });
        channels.project.guest({ read: 1, update: 0, delete: 0 });
        break;
      case 'attachment':
        publicRead();
        channels.organization.admin({ create: 1, read: 1, update: 1, delete: 1 });
        channels.organization.member({ create: 1, read: 'own', update: 0, delete: 0 });

        channels.project.admin({ create: 1, read: 1, update: 1, delete: 1 });
        channels.project.member({ create: 1, read: 1, update: 0, delete: 1 });
        channels.project.guest({ create: 0, read: 1, update: 0, delete: 0 });
        break;
      case 'label':
        channels.organization.admin({ create: 1, read: 1, update: 1, delete: 1 });
        channels.organization.member({ create: 0, read: 0, update: 0, delete: 0 });

        channels.project.admin({ create: 1, read: 1, update: 1, delete: 1 });
        channels.project.member({ create: 1, read: 1, update: 1, delete: 1 });
        channels.project.guest({ create: 0, read: 0, update: 0, delete: 0 });
        break;
      case 'task':
        publicRead();
        channels.organization.admin({ create: 1, read: 1, update: 1, delete: 1 });
        channels.organization.member({ create: 0, read: 0, update: 0, delete: 0 });

        channels.project.admin({ create: 1, read: 1, update: 1, delete: 1 });
        channels.project.member({ create: 1, read: 1, update: 1, delete: 1 });
        channels.project.guest({ create: 0, read: 1, update: 0, delete: 0 });
        break;
    }
  },
);
